import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import CustomViewPage from '../../components/CustomComponents/CustomViewPage'
import { useModuleAdmins } from '../../hooks/Authentication/useModuleAdmins'
import { formatDate } from '../../shared/constants'

export default function ViewModuleAdmin() {
  const { getModuleAdmin, moduleAdmin, loading } = useModuleAdmins()
  const params = useParams()

  const [data, setData] = useState([])

  useEffect(() => {
    getModuleAdmin({ moduleAdminId: params.moduleAdminId })
  }, [params.moduleAdminId])

  useEffect(() => {
    if (moduleAdmin) {
      setData([
        { label: 'Module Admin Code', data: moduleAdmin.moduleAdminCode },
        { label: 'Name', data: `${moduleAdmin.firstName} ${moduleAdmin.lastName}` },
        { label: 'Email', data: moduleAdmin.email },
        { label: 'Phone Number', data: moduleAdmin.phoneNumber },
        { label: 'Date of Birth', data: formatDate(moduleAdmin.dob) },
        { label: 'Permission', data: moduleAdmin.permissions && moduleAdmin.permissions.name },
      ])
    }
  }, [moduleAdmin])
  return <CustomViewPage loading={loading} heading="Module Admin" editUrl="moduleAdmin" id={params.moduleAdminId} redirect="ALL_MODULEADMINS" data={data} />
}
